import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Target, Shield, Heart, Users, BookOpen, Edit2, X, Check, Upload } from 'lucide-react';
export function About() {
  const [counselors, setCounselors] = useState([{
    id: 1,
    name: 'Bpk. Budi Santoso, S.Psi., M.Pd.',
    role: 'Koordinator BK',
    photo: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400'
  }, {
    id: 2,
    name: 'Ibu Siti Aminah, S.Pd.',
    role: 'Konselor Kelas X & XI',
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400'
  }, {
    id: 3,
    name: 'Bpk. Andi Wijaya, S.Psi.',
    role: 'Konselor Kelas XII',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=400'
  }]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editForm, setEditForm] = useState({
    name: '',
    photo: ''
  });
  const handleEditClick = (counselor: any) => {
    setEditingId(counselor.id);
    setEditForm({
      name: counselor.name,
      photo: counselor.photo
    });
  };
  const handleSave = (id: number) => {
    setCounselors(counselors.map(c => c.id === id ? {
      ...c,
      name: editForm.name,
      photo: editForm.photo
    } : c));
    setEditingId(null);
  };
  return <div className="bg-white min-h-screen" data-id="element-93">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-pink-100/50 via-purple-50/30 to-blue-100/50 py-16 md:py-24" data-id="element-94">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-95">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-96">
            Tentang Bimbingan & Konseling
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-97">
            BK hadir bukan sebagai "polisi sekolah", melainkan sebagai sahabat
            siswa untuk membantu mengembangkan potensi dan menyelesaikan masalah
            dengan pendekatan humanistik.
          </p>
        </div>
      </section>

      {/* Fungsi & Tujuan */}
      <section className="py-16" data-id="element-98">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-100">
            <div data-id="element-101">
              <div className="flex items-center gap-3 mb-6" data-id="element-102">
                <div className="p-3 bg-blue-100 text-blue-600 rounded-xl" data-id="element-103">
                  <Target size={24} data-id="element-104" />
                </div>
                <h2 className="text-3xl font-bold text-gray-800" data-id="element-105">Tujuan BK</h2>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-106">
                Membantu peserta didik mencapai perkembangan optimal dan
                kemandirian dalam kehidupannya pada aspek:
              </p>
              <ul className="space-y-4" data-id="element-107">
                <li className="flex items-start gap-3" data-id="element-108">
                  <div className="mt-1 bg-primary-light/30 p-1 rounded-full text-primary-dark" data-id="element-109">
                    <Check size={16} data-id="element-110" />
                  </div>
                  <div data-id="element-111">
                    <strong className="text-gray-800" data-id="element-112">Pribadi:</strong> Memahami
                    potensi diri, mengelola emosi, dan membangun karakter
                    positif.
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-113">
                  <div className="mt-1 bg-primary-light/30 p-1 rounded-full text-primary-dark" data-id="element-114">
                    <Check size={16} data-id="element-115" />
                  </div>
                  <div data-id="element-116">
                    <strong className="text-gray-800" data-id="element-117">Sosial:</strong>{' '}
                    Berkomunikasi efektif, berempati, dan membangun relasi yang
                    sehat.
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-118">
                  <div className="mt-1 bg-primary-light/30 p-1 rounded-full text-primary-dark" data-id="element-119">
                    <Check size={16} data-id="element-120" />
                  </div>
                  <div data-id="element-121">
                    <strong className="text-gray-800" data-id="element-122">Belajar:</strong>{' '}
                    Menemukan gaya belajar efektif dan merencanakan pendidikan
                    lanjutan.
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-123">
                  <div className="mt-1 bg-primary-light/30 p-1 rounded-full text-primary-dark" data-id="element-124">
                    <Check size={16} data-id="element-125" />
                  </div>
                  <div data-id="element-126">
                    <strong className="text-gray-800" data-id="element-127">Karier:</strong> Mengenali
                    minat bakat dan merencanakan masa depan karier.
                  </div>
                </li>
              </ul>
            </div>

            <div data-id="element-128">
              <div className="flex items-center gap-3 mb-6" data-id="element-129">
                <div className="p-3 bg-pink-100 text-pink-600 rounded-xl" data-id="element-130">
                  <Shield size={24} data-id="element-131" />
                </div>
                <h2 className="text-3xl font-bold text-gray-800" data-id="element-132">Fungsi BK</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-133">
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-134">
                  <h4 className="font-bold text-gray-800 mb-1" data-id="element-135">Pemahaman</h4>
                  <p className="text-sm text-gray-600" data-id="element-136">
                    Membantu siswa memahami diri dan lingkungannya.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-137">
                  <h4 className="font-bold text-gray-800 mb-1" data-id="element-138">Pencegahan</h4>
                  <p className="text-sm text-gray-600" data-id="element-139">
                    Mencegah timbulnya masalah yang dapat menghambat
                    perkembangan.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-140">
                  <h4 className="font-bold text-gray-800 mb-1" data-id="element-141">Pengentasan</h4>
                  <p className="text-sm text-gray-600" data-id="element-142">
                    Membantu mengatasi masalah yang sedang dihadapi siswa.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-143">
                  <h4 className="font-bold text-gray-800 mb-1" data-id="element-144">Pemeliharaan</h4>
                  <p className="text-sm text-gray-600" data-id="element-145">
                    Memelihara dan mengembangkan potensi positif siswa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program BK */}
      <section className="py-16 bg-gradient-to-b from-white to-pink-50/30" data-id="element-146">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
          <div className="text-center mb-12" data-id="element-148">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-149">
              Program Layanan BK
            </h2>
            <p className="text-gray-600" data-id="element-150">
              Berbagai bentuk layanan yang kami sediakan untuk mendukung siswa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-151">
            {[{
            title: 'Konseling Individual',
            desc: 'Layanan tatap muka/online untuk membantu siswa menyelesaikan masalah pribadi secara rahasia.',
            icon: <Heart data-id="element-152" />
          }, {
            title: 'Bimbingan Kelompok',
            desc: 'Diskusi kelompok untuk membahas topik-topik umum yang bermanfaat bagi perkembangan siswa.',
            icon: <Users data-id="element-153" />
          }, {
            title: 'Layanan Informasi',
            desc: 'Pemberian informasi terkait pendidikan, karier, dan isu-isu remaja terkini.',
            icon: <BookOpen data-id="element-154" />
          }].map((program, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-155">
                <div className="text-primary mb-4" data-id="element-156">{program.icon}</div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-157">
                  {program.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-158">{program.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Profil Konselor */}
      <section className="py-16" data-id="element-159">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
          <div className="text-center mb-12" data-id="element-161">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-162">
              Kenalan dengan Konselor Kami
            </h2>
            <p className="text-gray-600" data-id="element-163">
              Para profesional yang siap mendengarkan dan mendampingimu.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-164">
            {counselors.map(counselor => <div key={counselor.id} className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 group relative" data-id="element-165">
                {editingId === counselor.id ? <div className="p-6" data-id="element-166">
                    <div className="mb-4" data-id="element-167">
                      <label className="block text-xs font-bold text-gray-500 mb-1" data-id="element-168">
                        URL Foto
                      </label>
                      <input type="text" value={editForm.photo} onChange={e => setEditForm({
                  ...editForm,
                  photo: e.target.value
                })} className="w-full text-sm p-2 border rounded" data-id="element-169" />
                    </div>
                    <div className="mb-4" data-id="element-170">
                      <label className="block text-xs font-bold text-gray-500 mb-1" data-id="element-171">
                        Nama Lengkap
                      </label>
                      <input type="text" value={editForm.name} onChange={e => setEditForm({
                  ...editForm,
                  name: e.target.value
                })} className="w-full font-bold p-2 border rounded" data-id="element-172" />
                    </div>
                    <div className="flex gap-2 justify-end" data-id="element-173">
                      <button onClick={() => setEditingId(null)} className="p-2 text-gray-500 hover:bg-gray-100 rounded" data-id="element-174">
                        <X size={18} data-id="element-175" />
                      </button>
                      <button onClick={() => handleSave(counselor.id)} className="p-2 bg-primary text-white rounded" data-id="element-176">
                        <Check size={18} data-id="element-177" />
                      </button>
                    </div>
                  </div> : <>
                    <button onClick={() => handleEditClick(counselor)} className="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity shadow-sm z-10" data-id="element-178">
                      <Edit2 size={16} data-id="element-179" />
                    </button>
                    <div className="h-64 overflow-hidden" data-id="element-180">
                      <img src={counselor.photo} alt={counselor.name} className="w-full h-full object-cover" data-id="element-181" />
                    </div>
                    <div className="p-6 text-center" data-id="element-182">
                      <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-183">
                        {counselor.name}
                      </h3>
                      <p className="text-primary font-medium" data-id="element-184">
                        {counselor.role}
                      </p>
                    </div>
                  </>}
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}